import { NmsWizardStepConverter, NmsWizardStepMapData } from "@nms-angular-toolkit/nms-wizard";
import { DeviceLinkModel } from "../../1-devices/link-device-model";
import { GeneralLinkModel } from "../link-general-model";
import { Injectable } from "@angular/core";

/**
 * Serviço responsável por converter os dados de @see DeviceLinkModel para @see GeneralLinkModel.
 */
@Injectable({
    providedIn: "root"
})
export class LinkGeneralStepConverter implements NmsWizardStepConverter<DeviceLinkModel, GeneralLinkModel> {

    convert(deviceLinkModel: DeviceLinkModel, wizardStepsCacheMap: NmsWizardStepMapData): GeneralLinkModel {
        const generalLinkModel = wizardStepsCacheMap["GeneralLinkModel"] as GeneralLinkModel;
        generalLinkModel.aEndLink = deviceLinkModel.aEndLink;
        generalLinkModel.zEndLink = deviceLinkModel.zEndLink;

        return generalLinkModel;
    }
}
